module.exports = __webpack_public_path__ + "home-block-6-overlay-yLJ3IeH.png";